import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface UserForAssignment {
  id: string;
  name: string;
  email: string;
}

export function useUsersForAssignment() {
  const { data: users = [], isLoading, error } = useQuery({
    queryKey: ['users-for-assignment'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_users_for_license_assignment');

      if (error) {
        throw error;
      }

      return (data || []) as UserForAssignment[];
    },
  });

  return { users, isLoading, error };
}
